import { motion } from "framer-motion";
import { ShieldCheck, ScrollText, FileLock2 } from "lucide-react";
import { PRIVACY } from "@/constants/testIds";

const ITEMS = [
  {
    key: "isolation",
    icon: ShieldCheck,
    title: "Yours, and Only Yours",
    body: "Your processes and records never train models that serve anyone else.",
  },
  {
    key: "audit",
    icon: ScrollText,
    title: "Every Access on the Record",
    body: "A trail on every read and write, so you can always answer who saw what, and when.",
  },
  {
    key: "standard",
    icon: FileLock2,
    title: "Held to the Standard Your Work Demands",
    body: "We handle regulated, high-trust work the way it has to be handled — quietly, carefully, and on the record.",
  },
];

export default function Privacy() {
  return (
    <section
      id="privacy"
      data-testid={PRIVACY.root}
      className="relative bg-[#ffffff] border-t border-black/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-36">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 mb-16 md:mb-20">
          <div className="md:col-span-3">
            <div className="flex items-center gap-3 font-mono text-[12px] uppercase tracking-[0.3em] text-black/65">
              <span className="eyebrow-bar" aria-hidden="true" />
              <span>Privacy</span>
            </div>
          </div>
          <div className="md:col-span-9">
            <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[0.98] tracking-tightest max-w-3xl text-[#0a0a0a]">
              Your data
              <span className="italic font-light text-black/65"> stays yours.</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-black/15 border border-black/15">
          {ITEMS.map((it, idx) => {
            const Icon = it.icon;
            return (
              <motion.div
                key={it.key}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.7, delay: idx * 0.1 }}
                className="bg-[#ffffff] p-8 md:p-10 min-h-[280px] flex flex-col gap-6"
              >
                <div className="inline-flex items-center justify-center h-11 w-11 border border-black/20 text-[#0a0a0a]">
                  <Icon size={18} strokeWidth={1.4} />
                </div>
                <h3 className="font-serif text-2xl md:text-3xl leading-tight tracking-tight text-[#0a0a0a]">
                  {it.title}
                </h3>
                <p className="font-sans text-black/65 text-[15px] leading-relaxed">
                  {it.body}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
